import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Form as BTForm,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import MultiLanguageInputText from "../../../../../../components/Forms/MultiLanguageInputText";
import { FormColorSelect } from "../../../../../../components/UiComponents/ColorSelect";
import FormInputText from "../../../../../../components/Forms/FormInputText";
import FormSelectBox from "../../../../../../components/Forms/FormSelectBox";
import { useTranslation } from "react-i18next";

const ImportHolidaysDialog = ({ handleSuccess, toggle }) => {
  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    setLoading(true);
    axios
      .post(`/api/v1/holidays.json`, values)
      .then(function () {
        setTimeout(() => {
          setLoading(false);
          toggle();
          handleSuccess();
        }, 2000);
      })
      .catch(function (e) {
        setErrors(e.response.data);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const templateResponse = await axios.get("api/v1/holidays/template.json");
      setTemplate(templateResponse.data);
      setLoading(false);
    }

    getData();
  }, []);

  return (
    <Modal show={true} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>
          {t("settings.booking_planner.import_holidays_dialog.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{ type: "template", country: "", color: "" }}
          enableReinitialize={true}
          onSubmit={submit}
        >
          {() => (
            <Form autoComplete="false">
              {loading ? (
                <Spinner
                  className={"d-block mx-auto"}
                  animation="border"
                  variant="primary"
                />
              ) : (
                <>
                  <FormSelectBox
                    required={true}
                    label={t(
                      "settings.booking_planner.import_holidays_dialog.country.label"
                    )}
                    name={"country"}
                    options={template.configuration.countries}
                  ></FormSelectBox>

                  <FormColorSelect
                    label={"Farbe"}
                    name={"color"}
                    colors={template.configuration.colors}
                    open={true}
                  />
                </>
              )}
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportHolidaysDialog;
